import { useCallback, useRef, useState } from "react";

import { QuickSearchInput } from "@/components/_molecules/quick-search-input";

import { useUnsafeDatatableContext } from "./use-datatable-context";

export const DatatableQuickSearch = () => {
  const debounceTimerRef = useRef<NodeJS.Timeout | null>(null);
  const context = useUnsafeDatatableContext();
  const [inputValue, setInputValue] = useState(context?.state.globalFilter || "");

  const debouncedSetGlobalFilter = useCallback(
    (value: string) => {
      if (!context) return;
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }

      debounceTimerRef.current = setTimeout(() => {
        context.setState({ state: { globalFilter: value.trim() } });
        debounceTimerRef.current = null;
      }, 100);
    },
    [context],
  );

  const handleChange = (value: string) => {
    setInputValue(value);
    debouncedSetGlobalFilter(value);
  };

  const handleClear = () => {
    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    setInputValue("");
    context?.setState({ state: { globalFilter: "" } });
  };

  if (!context) {
    return null;
  }

  return <QuickSearchInput value={inputValue} onChange={handleChange} onClear={handleClear} />;
};
